module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Tendance.b6927c2d-ps.jpg";